import { createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";
import CategoryDetailComponent from "../pages/CategoryDetailComponent/CategoryDetailComponent";
import HomePage from "../pages/Home/HomePage";
import InformativePrivacy from "../pages/InformativePrivacy/InformativePrivacy";
import SearchPage from "../pages/SearchPage/SearchPage";
import HeaderComponent from "../components/HeaderComponent/HeaderComponent";
import FooterComponent from "../components/FooterComponent/FooterComponent";
import Cookie from "../pages/Cookie/Cookie";
import Accessibilita from "../pages/Accessibilita/Accessibilita";
import ArchivioRSSR from "../pages/ArchivioRSSR/ArchivioRSSR";
import CARDS_LIST_TO_VIEW from "../utils/Constans";

const routesMap = {
  HOME_PAGE: "/home",
  DETAGLIO_CATEGORIA: "/dettaglio-categorie",
  NO_PAGE: "/",
  INFORMATIVA_PRIVACY: "/informativa-privacy",
  SEARCH_PAGE: "/risultati-ricerca",
  COOKIE: "/cookie",
  ACCESSIBILITA: "/accessibilita",
  ARCHIVIO: "/archivio",
  SEZIONE:{
    POPOLAZIONEESALUTE: "/sezione/popolazione-e-salute",
    AREEINTERVENTO:"/sezione/aree-di-intervento",
    GESTIONERISORSE:"/sezione/gestione-risorse",
    ATTUAZIONEOBIETTIVIPSSR:"/sezione/attuazione-obiettivi-pssr"
  }
};



const router = createBrowserRouter([
  {
    element: <>
      <HeaderComponent />
      <div className="wrap-container"><Outlet /></div>
      <FooterComponent />
      <ScrollRestoration />
    </>,
    errorElement: <h1>ERROR PAGE!</h1>,
    children: [
      {
        path: routesMap.NO_PAGE,
        element: <HomePage />,
      },
      {
        path: routesMap.HOME_PAGE,
        element: <HomePage />,
      },
      {
        path: `${routesMap.DETAGLIO_CATEGORIA}/:id` ,
        element: <CategoryDetailComponent />,
      },
      {
        path: routesMap.SEZIONE.POPOLAZIONEESALUTE,
        element: <CategoryDetailComponent section={CARDS_LIST_TO_VIEW.find(sec => sec.tipologia === "01")} />,
      },
      {
        path: routesMap.SEZIONE.AREEINTERVENTO,
        element: <CategoryDetailComponent section={CARDS_LIST_TO_VIEW.find(sec => sec.tipologia === "02")} />,
      },
      {
        path: routesMap.SEZIONE.GESTIONERISORSE,
        element: <CategoryDetailComponent section={CARDS_LIST_TO_VIEW.find(sec => sec.tipologia === "03")} />,
      },
      {
        path: routesMap.SEZIONE.ATTUAZIONEOBIETTIVIPSSR,
        element: <CategoryDetailComponent section={CARDS_LIST_TO_VIEW.find(sec => sec.tipologia === "05")} />,
      },
      {
        path: routesMap.INFORMATIVA_PRIVACY,
        element: <InformativePrivacy />,
      },
      {
        path: routesMap.SEARCH_PAGE,
        element: <SearchPage />,
      },
      {
        path: routesMap.COOKIE,
        element: <Cookie />,
      },
      {
        path: routesMap.ACCESSIBILITA,
        element: <Accessibilita />,
      },
      {
        path: routesMap.ARCHIVIO,
        element: <ArchivioRSSR />,
      }
    ],
  }
]);

const getRouterForSection = (tipologia) => {
  switch (tipologia) {
      case '01':
          return routesMap.SEZIONE.POPOLAZIONEESALUTE;
      case '02':
          return routesMap.SEZIONE.AREEINTERVENTO;
      case '03':
          return routesMap.SEZIONE.GESTIONERISORSE;
      case '05':
          return routesMap.SEZIONE.ATTUAZIONEOBIETTIVIPSSR;
      default:
          return '';
  }
}

export {
  routesMap,
  router,
  getRouterForSection
};
